import { render, staticRenderFns } from "./QuickAccess.vue?vue&type=template&id=12b112e2&"
import script from "./QuickAccess.vue?vue&type=script&lang=js&"
export * from "./QuickAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports